import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { tradingApi } from '../services/api'
import { TradingStatus } from '../types'

interface TradingContextType {
  status: TradingStatus | null
  loading: boolean
  refresh: () => Promise<void>
  /** خرید از ما (سفارش BUY) مسدود است؟ */
  buyBlocked: boolean
  /** فروش به ما (سفارش SELL) مسدود است؟ */
  sellBlocked: boolean
  /** قیمت‌ها ستاره‌دار هستند؟ */
  pricesHidden: boolean
}

const TradingContext = createContext<TradingContextType | undefined>(undefined)

export const TradingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [status, setStatus] = useState<TradingStatus | null>(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    try {
      const res = await tradingApi.getStatus()
      if (res.data.success && res.data.data) setStatus(res.data.data)
    } catch {
      // در صورت خطا، فرض می‌کنیم همه چیز فعال است تا فروشگاه از کار نیفتد
      setStatus(null)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    refresh()
    // وضعیت استاپ را دوره‌ای به‌روز می‌کنیم تا تغییر مدیر فوری دیده شود
    const timer = setInterval(refresh, 20000)
    return () => clearInterval(timer)
  }, [refresh])

  const buyBlocked = !!status?.sellStopped
  const sellBlocked = !!status?.buyStopped

  return (
    <TradingContext.Provider
      value={{
        status,
        loading,
        refresh,
        buyBlocked,
        sellBlocked,
        pricesHidden: !!status?.pricesHidden
      }}
    >
      {children}
    </TradingContext.Provider>
  )
}

export const useTrading = () => {
  const ctx = useContext(TradingContext)
  if (!ctx) throw new Error('useTrading must be used within a TradingProvider')
  return ctx
}
